import React from 'react';

const Header = () => {
    return (
        <header className='header'>
            <div className='title'>
                <h1>Guess the Number</h1>
            </div>
        </header>
    );
};

export default Header;
